import {  storyPageContent } from "../data/services";
import { motion } from "framer-motion";
import ServicesBanner from "../components/common/ServicesBanner";
import userImg from "../assets/icons/CLIENTImg.png";
import OpportunitiesImg from "../assets/icons/OPPORTUNITIESImg.png";
import ChallengesImg from "../assets/icons/CHALLENEGS.jpg";
import SuccessImg from "../assets/icons/SUCCESS.jpg";
const SuccessStory1 = () => {

  const { bannerTitle, bannerImage } = storyPageContent;
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.2, duration: 0.5 },
    }),
  };
  const cards = [
    {
      title: "クライアントの背景", 
      img: userImg,
      description:
        "同クライアントは、デジタル決済ソリューションの先駆者である日本有数の上場企業です。同社は、EC事業者とエンドユーザーの両方にユーザーフレンドリーなシステムツールとサービスを開発、提供し、電子商取引企業がコア業務に集中できるようにしています。 ",
    },
    {
      title: "機会",
      img: OpportunitiesImg,
      description:
        "• クライアントは、単なる監視サービス以上のものを期待していました。 \n • 専任のチームを擁する専用のオフショアセンターを運営できるパートナー（ベンダーではない）を探していたのです。\n • 既存のとあるベンダーは、共有リソースを使用した共有監視サポートを提供していましたが、 \n • お客様は、アプリケーションのリリース活動でもサポートできるパートナーを求めていました。",
    },
    {
      title: "課題",
      img: ChallengesImg,
      description:
        "• 日本有数の決済ゲートウェイソリューションプロバイダーとして、インフラを24時間365日稼働させておくことは非常に重要でした。\n • そのため、上級管理職は即時の判断が必要とされるような状況下では常に待機している必要があったのです。\n",
    },
    {
      title: "解決策と成功",
      img: SuccessImg,
      description:
        "• 段階的にアプローチを開始し、4か月以内に、監視サポート体制を24時間365日にまで拡張しました。\n • 6か月以内に、アプリケーションのリリース活動にも対応できるようになりました。 \n • その結果、クライアントはリソースの計画が立てられるようになり、対応力が拡大しました。\n • インフラストラクチャやアプリケーションの改善に注力できるようになったことで、複数の新規加盟店の獲得に成功、収益が21%増加しました。",
    },
  ];
  return (
    <div className="bg-gradient-to-b from-white to-gray-100 mb-5 mx-auto">
      {/* Banner Section */}
      <ServicesBanner title={bannerTitle} heroImage={bannerImage} />
      <div className="max-w-5xl mx-auto md:px-10 lg:px-10 lg:max-w-fit mb-5">
        <div className="flex justify-center items-center">
          {/* Header Section */}
          <div className="m-5">
            <h1 className="text-3xl font-bold mt-2">
              <span>デジタルファイナンスのためのフィンテックソリューション</span>
            </h1>
          </div>
        </div>
        <div className="grid md:grid-cols-2 sm:grid-cols-1 gap-x-10 gap-y-10 w-full max-w-6xl mx-auto">
          {cards.map((card, i) => (
            <motion.div
              key={card.title}
              custom={i}
              initial="hidden"
              animate="visible"
              variants={cardVariants}
              whileHover={{ scale: 1.03 }}
              transition={{ type: "spring", stiffness: 300 }}
              className="bg-white rounded-2xl shadow-md hover:shadow-xl hover:shadow-blue-100 p-10 transition duration-300 ease-in-out"
            >
              <div className="flex items-center gap-4 mb-4">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-16 h-16 rounded-full border border-gray-200"
                />
                <h3 className="text-2xl font-semibold text-blue-700">
                  {card.title}
                </h3>
              </div>
              <p className="text-gray-800 leading-relaxed text-lg">
                {card.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SuccessStory1;
